export type CredentialField =
  | 'endpoint'
  | 'apiKey'
  | 'appKey'
  | 'appSecret'
  | 'accountNumber'
  | 'unmanagedAccountNumber'
  | 'dispatchReference'

export enum SupplierGroupId {
  Offline = 0,
  Magenta = 1,
  iCabbi = 2,
  Cordic = 3,
  Cabguru = 4,
  Cab9 = 5,
  Ivcardo = 6,
  Sixt = 7,
  Autocab = 8,
  Smartzi = 9,
  Gett = 10,
  Bolt = 11,
  Uber = 12,
  Blacklane = 13,
  Koi = 14,
  Talixo = 15,
  Dever = 16,
  GNet = 17,
  FreeNow = 18,
  Limos4 = 19,
  Sherlock = 20,
}

const supplierCredentialRules: Record<SupplierGroupId, CredentialField[]> = {
  [SupplierGroupId.Offline]: [],
  [SupplierGroupId.Magenta]: [
    'endpoint',
    'apiKey',
    'accountNumber',
    'unmanagedAccountNumber',
  ],
  [SupplierGroupId.iCabbi]: [
    'endpoint',
    'appKey',
    'appSecret',
    'accountNumber',
    'unmanagedAccountNumber',
  ],
  [SupplierGroupId.Cordic]: [
    'endpoint',
    'accountNumber',
    'unmanagedAccountNumber',
    'dispatchReference',
  ],
  [SupplierGroupId.Cabguru]: [
    'endpoint',
    'accountNumber',
    'unmanagedAccountNumber',
    'dispatchReference',
  ],
  [SupplierGroupId.Cab9]: ['endpoint', 'appKey', 'appSecret'],
  [SupplierGroupId.Autocab]: ['endpoint', 'dispatchReference'],
  [SupplierGroupId.Dever]: ['endpoint', 'dispatchReference'],
  [SupplierGroupId.GNet]: ['endpoint', 'dispatchReference'],
  [SupplierGroupId.Sherlock]: [
    'endpoint',
    'accountNumber',
    'unmanagedAccountNumber',
  ],

  [SupplierGroupId.Ivcardo]: [],
  [SupplierGroupId.Sixt]: [],
  [SupplierGroupId.Smartzi]: [],
  [SupplierGroupId.Gett]: [],
  [SupplierGroupId.Bolt]: [],
  [SupplierGroupId.Uber]: [],
  [SupplierGroupId.Blacklane]: [],
  [SupplierGroupId.Koi]: [],
  [SupplierGroupId.Talixo]: [],
  [SupplierGroupId.FreeNow]: [],
  [SupplierGroupId.Limos4]: [],
}

export function getRequiredCredentials(
  supplierGroupId: number,
): CredentialField[] {
  return supplierCredentialRules[supplierGroupId as SupplierGroupId] ?? []
}

const supplierOptionalCredentialRules: Partial<
  Record<SupplierGroupId, CredentialField[]>
> = {
  [SupplierGroupId.iCabbi]: ['dispatchReference'],
}

export function getOptionalCredentials(
  supplierGroupId: number,
): CredentialField[] {
  return (
    supplierOptionalCredentialRules[supplierGroupId as SupplierGroupId] ?? []
  )
}

export function getCredentialFields(
  supplierGroupId: number,
): CredentialField[] {
  return [
    ...getRequiredCredentials(supplierGroupId),
    ...getOptionalCredentials(supplierGroupId),
  ]
}

const singletonSupplierGroups: ReadonlySet<SupplierGroupId> = new Set([
  SupplierGroupId.Ivcardo,
  SupplierGroupId.Sixt,
  SupplierGroupId.Smartzi,
  SupplierGroupId.Gett,
  SupplierGroupId.Bolt,
  SupplierGroupId.Uber,
  SupplierGroupId.Blacklane,
  SupplierGroupId.Koi,
  SupplierGroupId.Talixo,
  SupplierGroupId.FreeNow,
  SupplierGroupId.Limos4,
])

export function isSingletonSupplierGroup(supplierGroupId: number): boolean {
  return singletonSupplierGroups.has(supplierGroupId as SupplierGroupId)
}
